<template>
    <TableLayout :columns="columns" :table-data="tableData">
        <template v-slot:cell(actions)="{ article }">
            <div
                class="select-row-indicator"
                :class="{
                    lastSelected: article.lastSelected
                }"
                :title="!article.selected ? 'Artikel markieren' : 'Markierung aufheben'"
                @click="select(article, $event)"
            >
                <font-awesome-icon v-if="!article.selected" icon="check" />
                <font-awesome-icon v-else icon="times" />
            </div>
        </template>
        <template v-slot:cell(name)="{ article }">
            {{ article.name }}
            <b-badge variant="dark">{{ article.dosageForm }}</b-badge>
        </template>
        <template v-slot:cell(onStorage)="{ article }">
            {{ article.onStorage ? "ja" : "nein" }}
        </template>
        <template v-slot:cell(priceNew)="{ article }">
            <NumberInput
                v-model="article.priceNew"
                class="price-new-input"
                @input="priceNewChanged(article)"
            />
        </template>
        <template v-slot:numberField="{ numberObj }">
            <div v-if="numberObj.withoutComma" class="text-sm-right">
                {{ numberObj.value || "" }}
            </div>
            <div v-else class="text-sm-right">
                {{
                    numberObj.value !== null && !isNaN(numberObj.value)
                        ? (numberObj.value.toFixed(2) + "").replace(".", ",")
                        : ""
                }}
            </div>
        </template>
        <!-- Preisänderungsdienst -->
        <template v-slot:cell(lastAbdaChange)="{ article }">
            <HumanReadableTime
                :date-only="true"
                :time="new Date(article.lastAbdaChange)"
            ></HumanReadableTime>
        </template>
    </TableLayout>
</template>

<script>
import NumberInput from "../../../components/widgets/NumberInput";
import { EventBus } from "../../../utils/EventBus";
import TableLayout from "./TableLayout";
import HumanReadableTime from "@/components/widgets/HumanReadableTime";

export default {
    name: "Table",
    components: { HumanReadableTime, TableLayout, NumberInput },
    props: {
        tableData: {
            type: Array,
            default: () => []
        },
        columns: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            lastPriceChangedArticle: undefined
        };
    },
    methods: {
        shiftSelect(index) {
            const lastSelected = this.tableData.findIndex(item => item.lastSelected);
            const currSelected = index;

            // handle as normal click
            if (lastSelected === currSelected) return;

            let targetItems;
            if (lastSelected > currSelected) {
                targetItems = this.tableData.slice(currSelected, lastSelected + 1);
            } else {
                targetItems = this.tableData.slice(lastSelected, currSelected + 1);
            }
            console.log(targetItems);

            // If all Items are "active", it sets them to default.
            // Otherwise, it sets them to "active"
            const rowVariant = targetItems.some(item => !item.selected);
            targetItems.forEach(item => (item.selected = rowVariant));
        },
        select(article, e) {
            const index = article.realIndex;
            let row = this.tableData[index];

            if (e.shiftKey) {
                console.log("shift select");
                this.shiftSelect(index);
                e.preventDefault();
            } else {
                // selected is only active if it wasn't before
                row.selected = !row.selected;
            }
            // set a new last selected
            this.tableData.forEach(function(item) {
                item.lastSelected = false;
            });
            row.lastSelected = true;

            this.$set(this.tableData, index, row);
            EventBus.$emit("update-table-view");
            this.$emit(
                "selected",
                this.tableData.filter(article => article.selected)
            );
        },
        priceNewChanged(article) {
            if (!isNaN(article.priceNew)) {
                if (article.priceNew < 0) {
                    article.priceNew *= -1;
                }
            } else {
                article.priceNew = null;
            }
            this.lastPriceChangedArticle = article;
            this.$store.commit("calculateArticleProfitMutation", this.lastPriceChangedArticle);
            this.$store.dispatch("calculateArticleProfitsOfList", [this.lastPriceChangedArticle]);
            this.$store.commit("changeArticle", article);
        }
    }
};
</script>

<style lang="scss">
#table-component {
    overflow: auto;
    overflow-anchor: none;
    flex: 1;
}
#busy-slot,
#error-slot {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 45vh;
}
#error-slot {
    font-weight: bold;
    color: $danger;
}

table {
    table-layout: fixed;
}
#table-component table tbody {
    font-size: 0.9em;
}

#table-component .select-row {
    display: flex;
    align-items: center;
}

#table-component .select-row-indicator {
    cursor: pointer;
    user-select: none;
}

#table-component .select-row-indicator.lastSelected {
    color: darken($primary, 20);
}

#table-component .select-row-interaction {
    cursor: pointer;
}

.table-striped tbody tr:nth-of-type(odd) > .lupus-success {
    background-color: $table-green;
}

tr:nth-of-type(odd).table-active > .lupus-success {
    background-color: darken($table-green, 15%);
}

.table-striped tbody tr:nth-of-type(even) > .lupus-success {
    background-color: $table-green-hl;
}

tr:nth-of-type(even).table-active > .lupus-success {
    background-color: darken($table-green-hl, 15%);
}

.table-striped tbody tr:nth-of-type(odd) > .lupus-warning {
    background-color: $table-yellow;
}

tr:nth-of-type(odd).table-active > .lupus-warning {
    background-color: darken($table-yellow, 15%);
}

.table-striped tbody tr:nth-of-type(even) > .lupus-warning {
    background-color: $table-yellow-hl;
}

tr:nth-of-type(even).table-active > .lupus-warning {
    background-color: darken($table-yellow-hl, 15%);
}

.table-striped tbody tr:nth-of-type(odd) > .lupus-info {
    background-color: $table-blue;
}

tr:nth-of-type(odd).table-active > .lupus-info {
    background-color: darken($table-blue, 15%);
}

.table-striped tbody tr:nth-of-type(even) > .lupus-info {
    background-color: $table-blue-hl;
}

tr:nth-of-type(even).table-active > .lupus-info {
    background-color: darken($table-blue-hl, 15%);
}

#table-component .price-new-input {
    width: 100%;
    border-radius: 0;
}

#table-component .article-name {
    overflow: hidden;
    text-overflow: ellipsis;
}

input[type="number"] {
    text-align: right;

    &:focus {
        text-align: left;
    }

    &::-webkit-inner-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
}

thead {
    user-select: none;
}
</style>
